// extracted by mini-css-extract-plugin
export default {"container":"imageWithDefault-module__container___aWgNu","image":"imageWithDefault-module__image___l4XCi"};